import React, { useState, Suspense, lazy } from "react";
import styles from "./App.module.css";
// Static Imports
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

// Lazy Loaded Components
const Hero = lazy(() => import("./components/Hero/Hero"));
// const About = lazy(() => import("./components/About/About"));
const CardList = lazy(() => import("./components/CardList/CardList"));
const LearnAboutAI = lazy(() => import("./components/Edu/LearnAI"));
// const ChatBot = lazy(() => import("./components/RealtorAI/ProAIChatBot"));
// const AboutVideo = lazy(() => import("./components/AboutVideo/AboutVideo"));
const FeaturesView = lazy(() => import("./Views/featuresView/FeaturesView"));
const Responsive = lazy(() => import("./components/Responsive/Responsive"));
// This is not chatbot - We have original chatbot in it's wrapper component
// const DeepChatBot = lazy(() => import("./components/DeepChatBot/DeepChatBot"));
const MainServices = lazy(() => import("./components/MainService/MainService"));
const FeaturedProperties = lazy(() =>
  import("./components/FeaturedProperties/FeaturedProperties")
);
const VideoBackground = lazy(() =>
  import("./components/VideoBackground/VideoBackground")
);

// from passport js tutorial
// var indexRouter = require("./index");
// var authRouter = require("./auth");

function App() {
  const [isChatOpen, setIsChatOpen] = useState(false);

  const toggleChat = () => {
    setIsChatOpen((prev) => !prev);
  };

  return (
    <>
      <div className={styles.App}>
        <div className={styles.wrapper}>
          <Navbar />
          <Suspense fallback={<div>Loading...</div>}>
            <Hero />
            <CardList />
            <FeaturedProperties />
            <VideoBackground />
            <LearnAboutAI />
            <MainServices />
            <Responsive />
            <FeaturesView />
          </Suspense>
          <Footer />
        </div>

        {/* <div className={styles.chatIcon} onClick={toggleChat}>
          <div className={styles.chatCircle}>💬</div>
        </div> */}

        {/* Chat Popup */}
        {/* {isChatOpen && (
          <div className={styles.chatPopup}>
            <div className={styles.chatHeader}>
              <span>RealtorBot - AI Assistant</span>
              <button className={styles.closeButton} onClick={toggleChat}>
                ✖
              </button>
            </div>
            <DeepChatBot />
          </div>
        )} */}
      </div>
    </>
  );
}

export default App;
